var OCS = OCS || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.Classes = OCS.Geometry.Classes || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Classes.GeometryRequestGroupThenable = new Class({
    Implements: [Class.Thenable, Options, Events],
    options: {
        start_timeout: 1000,
        event_name: "complete",
        timer: 30000
    },
    start_timeout: null,
    timeout: null,
    group: {},
    promises: [],
    bound_methods: {},
    resolved: false,
    initialize: function (promises, op) {
        this.setOptions(op);
        this.bound_methods.on_complete = this.on_complete.bind(this);
        this.promises = promises;
        this.timeout = setTimeout(this.on_timeout.bind(this),this.options.timer);
        this.start_timeout = setTimeout(this.start.bind(this), this.options.start_timeout);
    },
    start: function(method) {
        if(this.start_timeout !== null) {
            clearTimeout(this.start_timeout);
            this.start_timeout = null;
        }
        this.group = new GroupPromises(this.promises);
        this.group.addEvent(this.options.event_name, this.bound_methods.on_complete);
        if(!method) {
            method = this.start_loop.bind(this);
        }
        this.promises.each(method);
        return this;
    },
    cancel: function() {
        this.promises.each(this.cancel_loop.bind(this));
        if(this.start_timeout !== null) {
            clearTimeout(this.start_timeout);
            this.start_timeout = null;
        }
        if(this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.group = {};
        this.promises = [];
        this.resolved = true;
        this.reject({message: "Canceled"});
        return this;
    },
    cancel_loop: function(promise) {
        promise.cancel();
    },
    start_loop: function(promise) {
        promise.start();
    },
    on_complete: function(geometries) {
        if(this.resolved) {
            return;
        }
        geometries = Array.flatten(geometries);
        if(this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        this.group = {};
        this.resolved = true;
        this.resolve(geometries);
        this.fireEvent('complete', {result: geometries});
    },
    on_timeout: function() {
        this.resolved = true;
        this.reject({message: "Request timed out"});
        this.group = {};
        this.promises = [];
    }
});

(function(){

    this.GroupPromises = new Class({

        initialize: function(){
            this.instances = Array.flatten(arguments);
        },

        addEvent: function(type, fn){
            var instances = this.instances,
                len = instances.length,
                togo = len,
                args = new Array(len),
                self = this;

            instances.each(function(instance, i){
                instance.addEvent(type, function(){
                    if (!args[i]) togo--;
                    args[i] = arguments;
                    if (!togo){
                        fn.call(self, args, instances);
                        togo = len;
                        args = new Array(len);
                    }
                });
            });
        }
    });

})();

